export enum ShippingOptionType {
    RetailerShippingServices = "Generate your own shipping label",
    CustomerDropOff = "Customer drop-off",
    Collection = "Collect from customer",
    CustomerArrangedShipping = "Customer to arrange their own shipping",
}
